<template>
  <div class="search-history">
    <x-body-text class="search-history__header">Recent searches</x-body-text>
    <ul role="listbox" class="search-history__list">
      <!-- eslint-disable-next-line vuejs-accessibility/role-has-required-aria-props -->
      <li
        v-for="historyItem in searchHistoryDisplay"
        :key="historyItem"
        :aria-label="historyItem"
        role="option"
        class="search-history__list__item"
        data-test="search-history-item"
        tabIndex="0"
        @click.stop="$emit('search-history-selected', historyItem)"
        @keyup.enter="$emit('search-history-selected', historyItem)"
      >
        <x-icon
          icon="search/history"
          class="search-history__list__item__icon"
        />
        <x-subtitle size="3" class="result-history-title">
          {{ historyItem }}
        </x-subtitle>
        <button
          class="search-history__list__item__remove"
          :title="`Delete ${historyItem} from history`"
          data-test="remove-search-history-item"
          @click.stop="removeFromHistory(historyItem)"
        >
          <x-icon
            icon="search/delete"
            class="search-history__list__item__remove__icon"
          />
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {
  searchHistoryDisplay,
  removeFromHistory,
} from '@/services/search-service'

import xBodyText from '@/components/shared/x-body-text/index.vue'
import xIcon from '@/components/shared/x-icon/index.vue'
import xSubtitle from '@/components/shared/x-subtitle/index.vue'

defineEmits(['search-history-selected'])
</script>

<style lang="scss" scoped>
$spacing-20: 20px;

.search-history {
  &__header {
    margin-top: $spacing-20;
    color: var(--ys-color-text-dim);
    padding-left: $spacing-20;
  }

  &__list {
    &__item {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: $spacing-20 0 $spacing-20 $spacing-20;
      border-bottom: 1px solid var(--ys-color-divider-base);

      &:hover,
      &:focus {
        background-color: var(--ys-color-background-secondary);
        outline: none;
      }

      &:last-child {
        border-bottom: none;
      }

      &__icon {
        margin-right: 10px;
        width: 28px;
        height: 28px;
      }

      &__remove {
        cursor: pointer;
        margin-left: auto;
        margin-right: 12px;
        background-color: transparent;
        padding: 8px;

        &__icon {
          display: block;
          width: 14px;
          height: 14px;
        }

        &:hover,
        &:focus {
          outline: none;

          &:deep(svg) {
            fill: var(--ys-color-icon-primary);
          }
        }
      }
    }
  }
}
</style>
